import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompanyViewComponent } from './company-view.component';
import { CompanyViewListComponent } from './company-view-list/company-view-list.component';
import { CompanyViewDetailComponent } from './company-view-detail/company-view-detail.component';
// import { FlexLayoutModule } from '@angular/flex-layout';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { EmpresaComponent } from './company-view-detail/empresa/empresa.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; 
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { AtributosComponent } from './company-view-detail/atributos/atributos.component';
import { MatTreeModule } from '@angular/material/tree';
import { MatRadioModule } from '@angular/material/radio';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { PersonalDeContactoComponent } from './company-view-detail/personal-de-contacto/personal-de-contacto.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RegisterTabComponent } from './company-view-detail/register-tab/register-tab.component';
import { ConveniosComponent } from './company-view-detail/convenios/convenios.component';
import { DashboardComponent } from './company-view-detail/dashboard/dashboard.component';
import { BaseChartDirective   } from 'ng2-charts';
import { DocumentsComponent } from './company-view-detail/documents/documents.component';
import { CreateCompanyComponent } from './company-view-list/create-company/create-company.component';
import { AttachedCompaniesComponent } from './company-view-detail/empresa/attached-companies/attached-companies.component';
import { ContactsComponent } from './company-view-detail/personal-de-contacto/contacts/contacts.component';
import { AgendaPopupComponent } from './company-view-detail/register-tab/agenda-popup/agenda-popup.component';
import { VisitaDeEmpresaPopupComponent } from './company-view-detail/register-tab/visita-de-empresa-popup/visita-de-empresa-popup.component';
import { ReunionPopupComponent } from './company-view-detail/register-tab/reunion-popup/reunion-popup.component';
import { RevisionPopupComponent } from './company-view-detail/register-tab/revision-popup/revision-popup.component';
import { ConveniosPopupComponent } from './company-view-detail/convenios/convenios-popup/convenios-popup.component';
import { DocumentPopupComponent } from './company-view-detail/documents/document-popup/document-popup.component';
import { ValoresActualesComponent } from './company-view-detail/atributos/valores-actuales/valores-actuales.component';
import { SharedModule } from '../common/shared.module';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FuseShortcutsModule } from '../fuse/components/shortcuts/shortcuts.module';
import { MoveCompanyComponent } from './company-view-list/move-company/move-company.component';
import { AngularMaterialModule } from 'app/angular-material.module';




@NgModule({
    declarations: [
        CompanyViewComponent,
        CompanyViewListComponent,
        CompanyViewDetailComponent,
        EmpresaComponent,
        AtributosComponent,
        PersonalDeContactoComponent,
        RegisterTabComponent,
        ConveniosComponent,
        DashboardComponent,
        DocumentsComponent,
        CreateCompanyComponent,
        AttachedCompaniesComponent,
        ContactsComponent,
        AgendaPopupComponent,
        VisitaDeEmpresaPopupComponent,
        ReunionPopupComponent,
        RevisionPopupComponent,
        ConveniosPopupComponent,
        DocumentPopupComponent,
        ValoresActualesComponent,
        MoveCompanyComponent,
    ],
    imports: [
        CommonModule,
        FlexLayoutModule,
        MatIconModule,
        MatTabsModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatDatepickerModule,
        MatCheckboxModule,
        FormsModule,
        ReactiveFormsModule,
        MatSortModule,
        MatTableModule,
        MatTreeModule,
        MatRadioModule,
        MatPaginatorModule,
        MatMenuModule,
        MatSlideToggleModule,
        MatTooltipModule,
        BaseChartDirective ,
        SharedModule,
        FuseShortcutsModule,
        AngularMaterialModule
    ],
    providers: [
        { provide: MAT_DIALOG_DATA, useValue: {} }
    ]
})
export class CompanyViewModule { }

